import { useDispatch, useSelector } from "react-redux"
import ToolBar from "../../components/ToolBar";
import BootstrapTable from 'react-bootstrap-table-next';
import { rptActions, helperActions } from '../../_actions';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import RptForm from "../../containers/rpts/RptForm";
import Dialog from "../../components/Dialog";
import { useState, useEffect } from "react";
import AccessMenu from "../../_helpers/access-menu";

const defaultSorted = [{
    dataField: 'client_id',
    order: 'asc'
}, {
    dataField: 'document_type',
    order: 'asc'
}, {
    dataField: 'rpt_name',
    order: 'asc'
}];

const RemoteFilter = ({ data, page, sizePerPage, onTableChange, totalSize, clientList }) => {
    const { selected } = useSelector(state => state.rpt)
    const { menus } = useSelector(state => state.authentication);
    const dispatch = useDispatch();

    const rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            if (AccessMenu.validAccess(menus, 5903)) {
                dispatch(rptActions.updateRpt(row))
                dispatch(helperActions.showForm(true))
            }

        },
        onClick: (e, row, rowIndex) => {
            if (AccessMenu.validAccess(menus, 5904)) {
                dispatch(rptActions.updateRpt(row))
            }            
        }
    };

    const columns = [{
        dataField: 'id',
        text: 'ID',
        hidden: true
    }, {
        dataField: 'client_id',
        text: 'Client ID',
        filter: selectFilter({
            options: clientList
        }),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        },

    }, {
        dataField: 'document_type',
        text: 'Document Type',
        filter: textFilter(),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '300px', textAlign: 'center' };
        }
    }, {
        dataField: 'rpt_name',
        text: 'Report Name',
        filter: textFilter(),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '300px', textAlign: 'center' };
        }
    }];

    const handleOnSelect = (row, isSelect) => {

        if (isSelect) {
            dispatch(rptActions.onSelectRpt([row.id]))
        } else {
            dispatch(rptActions.onSelectRpt([]))
        }
    }
    const selectRow = {
        mode: 'checkbox',
        selected: selected,
        clickToSelect: true,
        onSelect: handleOnSelect,
        hideSelectAll: true,

    };



    return <BootstrapTable
        bootstrap4
        remote
        keyField="id"
        data={data}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory({ page, sizePerPage, totalSize, "withFirstAndLast": false })}
        onTableChange={onTableChange}
        rowEvents={rowEvents}
        defaultSorted={defaultSorted}
        selectRow={selectRow}
        noDataIndication={'no results found'}
    />;
};

const RptConfigList = () => {
    const { height, currentpage, currentSizePerPage, showForm, showDialog, clientList } = useSelector(state => state.helper);
    const dispatch = useDispatch();
    const { data, selected, client_id, rpt_name, document_type, id } = useSelector(state => state.rpt);
    const [_filters, setFilters] = useState({})
    const [_sorting, setSorting] = useState({})
    const [_paging, setPaging] = useState({})
    const [_first, setFirst] = useState({})
    const [_last, setLast] = useState({})


    const [mounted, setMounted] = useState(false)

    if (!mounted) {
        dispatch(helperActions.getClientList())
    }

    useEffect(() => {
        setMounted(true)
        // eslint-disable-next-line
    }, []);

    const handleTableChange = (type, { filters, sortField, sortOrder, page, sizePerPage }) => {

        dispatch(rptActions.onSelectRpt([]))
        let sorting = { [sortField]: sortOrder }
        const paging = { currentpage, page, currentSizePerPage, sizePerPage }
        let first = {}
        let last = {}
        if (data.length > 0) {
            first = data[0]
            last = data[data.length - 1]
        }

        setFilters(filters)
        setSorting(sorting)
        setPaging(paging)
        setFirst(first)
        setLast(last)
        dispatch(rptActions.getRptConfigList({}, filters, sorting, paging, first, last, type));
    }

    const _createRptConfig = () => {
        dispatch(rptActions.createRpt({}))
        dispatch(helperActions.showForm(true))
    };

    const _deleteRptConfig = () => {

        dispatch(helperActions.showDialog(true))
    }

    const _handleClose = () => {
        dispatch(helperActions.showDialog(false))
    }

    const _handleSubmit = () => {
        dispatch(rptActions.deleteRptConfig(id, client_id, rpt_name, document_type, _filters, _sorting, _paging, _first, _last, 'sort'))
    }

    return (

        <div>
            <ToolBar menu="Report Template Config"
                create={_createRptConfig}
                delete={_deleteRptConfig} showDeleted={selected.length > 0} />
            <div style={{ position: "relative", height: height, overflow: "auto" }}>
                <RemoteFilter

                    data={data}
                    page={currentpage}
                    sizePerPage={currentSizePerPage}
                    totalSize={data.length > 0 ? data[0].tot_rec : 0}
                    onTableChange={handleTableChange}
                    clientList={clientList}
                />
                {showForm && <RptForm />}
                {showDialog && <Dialog handleClose={_handleClose} handleSubmit={_handleSubmit}
                    message={"Delete Report Templare Config '" + client_id + " " + rpt_name + " " + document_type + "'?"} />}

            </div>
        </div>
    )

}
export default RptConfigList
